import { createFileRoute } from '@tanstack/react-router';
import { SummerLandingPage } from '@features/landing/summer/pages/SummerLandingPage';
import { PremiumLinksProvider } from '@features/landing/shared/providers/PremiumLinksProvider';

export const Route = createFileRoute('/summer/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PremiumLinksProvider>
      <SummerLandingPage />
    </PremiumLinksProvider>
  );
}
